import axios from 'axios'
import rez from '../../../mixins/rezolutionWindow'
import router from '../../../router/index'

const api = process.env.VUE_APP_URL;
const cloneDeep = require('clone-deep')

export default {
  namespaced: true,
  state() {
    return {
      showAddEventNamePopup: false,
      event: {
        eventTitle: '',
        textBlock: false,
        textContent: ``,
        commentsBlock: false,
        enclosureBlock: false
      },
      typeCreate: '',
      tempData: {},
      isClearType: false,
      eventType: '',
      eventTemplates: [],
      events: [],
      eventsRoles: [],

      eventTypes: '',
      selectedType: {
        name: 'Все',
        value: ''
      },
      selectedDevice: {
        name: 'Все',
        value: ''
      },
      isCloseAllEditors: false
    }
  },
  getters: {
    event(state) {
      return state.event
    }
  },
  mutations: {
    SET_SELECTED_TYPE(state,data) {
      state.selectedType = data
    },
    SET_SELECTED_DEVICE(state,data) {
      state.selectedDevice = data
    },
    SET_TYPE_CREATE(state,data) {
      state.typeCreate = data
    },
    SET_EVENT_TYPES(state,data) {
      let arr  = data.map(item => {
        return {
          name: item,
          value: item
        }
      });
      arr.unshift({
        name: 'Все',
        value: ''
      });
      state.eventTypes = arr
    },
    RESET_EVENT(state) {
      state.event = {
        eventTitle: '',
        thing: '',
        textBlock: false,
        textContent: ``,
        commentsBlock: false,
        enclosureBlock: false
      }
      state.eventType = ''
    },
    SET_EVENT_TYPE(state,data) {
      state.eventType = data
    },
    SET_THING(state,data) {
      state.event.thing = data
    },
    SET_TEXT_BLOCK(state,data) {
      state.event.textBlock = data
    },
    SET_TEXT_CONTENT(state,data) {
      state.event.textContent = data
    },
    SET_EVENT_TITLE(state,data) {
      state.event.eventTitle = data
    },
    SET_EVENT_COMMENTS_BLOCK(state,data) {
      state.event.commentsBlock = data
    },
    SET_EVENT_ENCLOSURE_BLOCK(state,data) {
      state.event.enclosureBlock = data
    },
    SET_EVENT_TEMPLATES(state,data) {
      state.eventTemplates = data
    },
    SET_EVENT(state,data) {
      state.event = data
    },
    SET_DEVICE_EVENTS(state,data) {
      state.events = data.events.map(item => {
        return {
          ...item,
          files: item.files.map(file => {
            return {
              ...file,
              renameFile: false
            }
          }),
          addComment: false,
          edit: false
        }
      })
    },
    SET_EVENTS_ROLES(state,data) {
      state.eventsRoles = data
    },
    SET_EDIT_EVENT(state,data) {
      let arr = [ ...state.events ];
      arr.forEach((item, index) => {
        item.edit = false
        if (item.id === data.id) {
          item.edit = data.marker
        }
      })
      state.events = arr;
    },
    SET_ADD_COMMENT(state,data) {
      let arr = cloneDeep(state.events);
      for (let i = 0; i < arr.length; i++) {
        arr[i].addComment = false
        if (arr[i].id === data.event.id) {
          arr[i].addComment = data.marker;
        }
      };
      state.events = arr;
    },
    SET_SHOW_ADD_EVENT_NAME_POPUP(state,data) {
      state.showAddEventNamePopup = data
    },
    SET_TEMP_DATA(state,data) {
      state.tempData = data
    },
    SET_CLEAR_TYPE(state,data) {
      state.isClearType = data
      // setTimeout(() => this.isClearType = false, 1200)
    },
    SET_RENAME_FILE(state,data) {
      let arr = cloneDeep(state.events);
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (i == data.index) {
          for (let j = 0; j < item.files.length; j++) {
            if (j == data.fileIndex) {
              item.files[j].renameFile = data.marker;
              break;
            }
          }
          break;
        }
      };
      state.events = arr;
    }
  },
  actions: {
    //создание события
    async createEvent({state,commit,dispatch, rootState}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/create-event`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //создание шаблона вещи по device_id
    async saveEventTemplate({state,commit,dispatch, rootState}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/create-event-template`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('RESET_EVENT');
        dispatch('getEventTemplates', router.currentRoute.params.id)

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //удаление шаблона вещи по device_id
    async deleteEventTemplate({state,commit,dispatch, rootState}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/delete-event-template`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getEventTemplates', router.currentRoute.params.id)

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //получение событий по device_id
    async getEvents({state,commit,dispatch, rootState}, data) {
      let params = '';
      if (data.search) {
        params = params + '&text_or_title_filter=' + data.search
      }
      if (data.event_type) {
        params = params + '&type_filter=' + data.event_type
      }
      if (data.start_date && data.end_date) {
        params = params + '&start_date=' + data.start_date + '&end_date=' + data.end_date
      }
      await axios({
        method: 'get',
        url: `${api}logbook/get-events?device_id=${data.id}` + params,
        //url: `${api}logbook/get-event-templates`,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_DEVICE_EVENTS', res.data);
        commit('SET_EVENTS_ROLES', res.data.roles);
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //получение шаблона вещи по device_id
    async getEventTemplates({state,commit,dispatch, rootState}, id) {
      await axios({
        method: 'get',
        url: `${api}logbook/get-event-templates?device_id=${id}`,
        //url: `${api}logbook/get-event-templates`,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_EVENT_TEMPLATES', res.data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //получение всех типов событий вещи по device_id
    async getEventTypes({state,commit,dispatch, rootState}, id) {
      await axios({
        method: 'get',
        url: `${api}logbook/get-event-types?device_id=${id}`,
        //url: `${api}logbook/get-event-templates`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_EVENT_TYPES', res.data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //updateEvent
    async updateEvent({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/update-event`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
          let res = e.response.data;

          if (res.message.includes('access')) {
            dispatch('auth/logout', '', {root: true})
          };
        })
    },
    //del event
    async deleteEvent({rootState,dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/delete-event`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      })
    },

    //add files
    async addEventFiles({state,rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/add-event-files`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async renameEventFile({state,rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/rename-event-file`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async deleteEventFile({state,rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/delete-event-file`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async addEventComment({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/add-event-comment`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async updateEventComment({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/update-event-comment`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async deleteEventComment({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/delete-event-comment`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //confirm
    async confirmEvent({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}logbook/confirm-event`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },


  }
}
